import { z } from 'zod';
import { createRESTContract } from '../../index';
import {
  HomeDataSchema,
  HomeOverviewSchema,
  IntelligenceQuerySchema,
  IntelligenceQuestionsQuerySchema,
  IntelligenceQuestionsResponseSchema,
  IntelligenceResponseSchema,
  StudioPerformanceQuerySchema,
  StudioPerformanceSchema,
  WhatsChangedQuerySchema,
  WhatsChangedResponseSchema,
} from './home.schema';

export const homeContract = createRESTContract({
  getHomeData: {
    method: 'GET',
    path: '/home',
    permissions: [],
    response: HomeDataSchema,
  },
  getHomeOverview: {
    method: 'GET',
    path: '/home/overview',
    permissions: [],
    response: HomeOverviewSchema,
  },
  getIntelligence: {
    method: 'GET',
    path: '/home/intelligence',
    permissions: [],
    body: z.undefined(),
    query: IntelligenceQuerySchema,
    response: IntelligenceResponseSchema,
  },
  getIntelligenceQuestions: {
    method: 'GET',
    path: '/home/intelligence/questions',
    permissions: [],
    body: z.undefined(),
    query: IntelligenceQuestionsQuerySchema,
    response: IntelligenceQuestionsResponseSchema,
  },
  getStudioPerformance: {
    method: 'GET',
    path: '/home/studio-performance',
    permissions: [],
    body: z.undefined(),
    query: StudioPerformanceQuerySchema,
    response: StudioPerformanceSchema,
  },
  getWhatsChanged: {
    method: 'GET',
    path: '/home/whats-changed',
    permissions: [],
    body: z.undefined(),
    query: WhatsChangedQuerySchema,
    response: WhatsChangedResponseSchema,
  },
});
